import React, { Component } from "react";
import Select from "react-select";

export default class SelectInput extends Component {
  render() {
    const currentOptions = [...this.props.options];
    const optionsExist = !!currentOptions;
    const optionsNotEmpty = optionsExist && currentOptions.length > 0;

    if (
      optionsNotEmpty &&
      currentOptions[0].value !== undefined &&
      this.props.includeAllOption
    ) {
      currentOptions.unshift({ value: undefined, label: "All" });
    }

    return (
      <div className={`col-md-${this.props.widthRatio}`} id="check_form">
        <label>{this.props.label}</label>
        <Select
          value={this.props.value}
          onChange={(value) => this.props.onChange(value, this.props.inputKey)}
          options={currentOptions}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>
    );
  }
}
